import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wf-doing",
  "use": "icon-wf-doing-usage",
  "viewBox": "0 0 201.2 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 201.2 200\" id=\"icon-wf-doing\">\n<g>\n\t<rect x=\"49.5\" y=\"40.7\" class=\"st0\" width=\"20.6\" height=\"123.7\" />\n\t<rect x=\"8.3\" y=\"40.7\" class=\"st0\" width=\"20.6\" height=\"123.7\" />\n\t<path class=\"st0\" d=\"M92.8,152V51c0-12.4,8.2-20.6,20.6-20.6c4.1,0,10.3,2.1,12.4,4.1L185.6,84c8.2,8.2,10.3,20.6,2.1,28.9\n\t\tl-2.1,2.1l-59.8,49.5c-8.2,8.2-22.7,6.2-28.9-2.1C94.9,162.3,92.8,158.2,92.8,152z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol